/**
 * 랜덤 ID 생성 (영문소문자+숫자)
 * @example randomId() => 'x7k9m2p4'
 * @example randomId(16) => 'a3f8k2m9x7p4q1w5'
 */
export function randomId(length: number = 8): string {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
  let result = ''

  for (let i = 0; i < length; i++) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }

  return result
}
